import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ObjectCard from '@/shared/ui/ObjectCard/ObjectCard.vue'
import { Store, useStore } from 'vuex'
import {
    computed,
    inject,
    onActivated,
    onDeactivated,
    onMounted,
    ref,
    watch,
} from 'vue'
import {
    AGNKSEntityState,
    AGNKSObject,
} from '@/entities/ANGKS/model/AGNKSEntity.types'
import { MapEntityState } from '@/app/providers/store/modules/mapEntity/mapEntity.types'
import loadSource from '@/entities/Map/general/model/loadSource'
import { useRoute } from 'vue-router'
import { ObjectCardProps } from '@/shared/ui/ObjectCard/ObjectCard.types'
import {
    GENERAL_STATUSES_MAPPING_RU,
    stepsListIndexes,
} from '@/shared/constants'
import menuGoBack from '@/widgets/MenuPanel/ui/MainMenuView/methods/menuGoBack'


export default /*#__PURE__*/_defineComponent({
  __name: 'ObjectPageAGNKS',
  setup(__props) {

const appContext = inject<any>('appContext')
const store = useStore()
const route = useRoute()

const isComponentActive = ref(false)

const focusedRegionNumber = computed(() => store.state.focusedRegionNumber)
const focusedObject = computed(() => store.state.map.focusedObject)
const activeAgnksObject = computed<AGNKSObject | null>(
    () => store.state.AGNKSEntity.activeObject
)
const stepActiveId = computed<string>(() => store.state.view.stepActiveId)

const infoFields = computed<ObjectCardProps['infoFields']>(() => {
    return [
        {
            label: 'Статус',
            value:
                activeAgnksObject.value?.status &&
                GENERAL_STATUSES_MAPPING_RU[activeAgnksObject.value?.status],
        },
        {
            label: 'Год',
            value: activeAgnksObject.value?.year,
        },
        {
            label: 'Мощность',
            value: activeAgnksObject.value?.power,
        },
        {
            label: 'Владелец',
            value: activeAgnksObject.value?.owner,
        },
        {
            label: 'Поставщик',
            value: activeAgnksObject.value?.provider,
        },
    ]
})
// const addressFull = computed(() => `${(activeAgnksObject.value?.region || '') + (activeAgnksObject.value?.address && (', ' + activeAgnksObject.value?.address))}`)

const isLoading = ref(false)

const setAgnksActiveObject = async () => {
    if (!focusedObject.value?.id) return

    isLoading.value = true
    await store.dispatch('AGNKSEntity/loadById', {
        loadFn: appContext.loadSource,
        id: focusedObject.value.id,
    })
    isLoading.value = false
}

onMounted(async () => {
    await setAgnksActiveObject()
})
onActivated(async () => {
    isComponentActive.value = true
    await setAgnksActiveObject()
})
onDeactivated(async () => {
    isComponentActive.value = false
})

watch(
    () => focusedObject.value,
    async newFocusedObject => {
        if (!isComponentActive.value) return

        if (
            !newFocusedObject &&
            stepActiveId.value === stepsListIndexes.agnksInfoStepIndex
        ) {
            store.commit('setIsAutomaticZoomChangeLocked', {
                isLocked: true,
            })
            menuGoBack.call(appContext)
            // appContext.$state.map.isAutomaticZoomChangeLocked = false
            return
        }
        await setAgnksActiveObject()
    }
)
watch(focusedRegionNumber, () => {
    if (!isComponentActive.value) return
    menuGoBack.call(appContext)
})

return (_ctx: any,_cache: any) => {
  const _component_f7_card = _resolveComponent("f7-card")!

  return (_openBlock(), _createBlock(_component_f7_card, {
    outline: "",
    style: _normalizeStyle({ padding: 'var(--indent2)' })
  }, {
    default: _withCtx(() => [
      _createVNode(ObjectCard, {
        title: activeAgnksObject.value?.name,
        subtitle: activeAgnksObject.value?.address,
        "is-loading": isLoading.value,
        "info-fields": infoFields.value
      }, null, 8, ["title", "subtitle", "is-loading", "info-fields"])
    ]),
    _: 1
  }, 8, ["style"]))
}
}

})